module.exports = __webpack_public_path__ + "static/media/one-market-abstract.cacb1dca.png";